<ng-template #template let-row="row">
  <mat-chip
    *ngIf="
      row.orderingInformation.distributionChainState === distributionChainState.BlockedForReturn ||
      row.orderingInformation.distributionChainState === distributionChainState.TemporaryReturnBlockWebshop
    "
    disableRipple
  >
    {{ 'cart.cart-column-blocked-for-return' | translate }}
  </mat-chip>
</ng-template>
